module.exports = __webpack_public_path__ + "img/logo-sas-branca.10b7a95d.png";